import React from "react";
import { useAuth } from "../../context/AuthContext";

export default function TopBar() {
  const { user, signOut } = useAuth();

  // Get display name from email (part before @)
  const displayName = user?.email
    ? user.email.split("@")[0].replace(/\./g, " ").replace(/\b\w/g, c => c.toUpperCase())
    : "";

  return (
    <div style={{
      height:          "var(--topbar-height)",
      backgroundColor: "var(--bg-sidebar)",
      borderBottom:    "1px solid var(--border-sidebar)",
      display:         "flex",
      alignItems:      "center",
      justifyContent:  "space-between",
      padding:         "0 24px",
      flexShrink:      0,
      zIndex:          100,
    }}>
      {/* Left — Brand */}
      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
        <div style={{
          width:"28px", height:"28px",
          backgroundColor:"var(--accent-gold)",
          borderRadius:"6px",
          display:"flex", alignItems:"center", justifyContent:"center",
          fontWeight:700, fontSize:"13px", color:"#0F1C2E", letterSpacing:"-0.5px",
        }}>
          AP
        </div>
        <div>
          <div style={{ fontSize:"13px", fontWeight:600, color:"#FFFFFF", lineHeight:1.2 }}>AMPM Fashions</div>
          <div style={{ fontSize:"10px", color:"var(--accent-gold)", fontWeight:500, letterSpacing:"0.5px" }}>CEO COCKPIT</div>
        </div>
      </div>

      {/* Right — User info + sign out */}
      <div style={{ display:"flex", alignItems:"center", gap:"16px" }}>
        {/* Last updated */}
        <div style={{ fontSize:"12px", color:"var(--text-muted)" }}>
          <span style={{ color:"#94A3B8" }}>Last updated: </span>
          <span style={{ color:"#CBD5E1" }}>3 Sep 2026, 17:27</span>
        </div>

        {/* User avatar + name + role */}
        <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
          <div style={{
            width:"28px", height:"28px", borderRadius:"50%",
            backgroundColor:"#1E3A5F",
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:"11px", fontWeight:600, color:"#CBD5E1",
          }}>
            {displayName.split(" ").map((w: string) => w[0]).join("").slice(0,2).toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize:"12px", color:"#CBD5E1", fontWeight:500 }}>{displayName}</div>
            <div style={{ fontSize:"10px", color:"var(--accent-gold)" }}>{user?.role || ""}</div>
          </div>
        </div>

        {/* Sign out button */}
        <button
          onClick={signOut}
          style={{
            padding:"5px 12px", borderRadius:"5px",
            border:"1px solid #1E3A5F",
            backgroundColor:"transparent", color:"#64748B",
            fontSize:"11px", fontWeight:500, cursor:"pointer",
            transition:"all 0.15s",
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor = "#1E3A5F";
            (e.currentTarget as HTMLButtonElement).style.color = "#CBD5E1";
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor = "transparent";
            (e.currentTarget as HTMLButtonElement).style.color = "#64748B";
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
